import React from 'react';
import { Col, Form } from 'react-bootstrap';

import type { ChangeFormValues } from '../changeValidation';

type Props = {
  idPrefix: string;
  form: Pick<ChangeFormValues, 'sap_classification'>;
  onFormChange: (patch: Partial<ChangeFormValues>) => void;
  colMd?: number;
};

/** SAP / Não SAP (formulário legado sem builder). «Tem request?» é campo nativo no cadastro do formulário. */
const ChangeSapRequestFields: React.FC<Props> = ({ idPrefix, form, onFormChange, colMd = 6 }) => {
  return (
    <Col xs={12} md={colMd}>
      <Form.Label>SAP ou Não SAP</Form.Label>
      <div>
        <Form.Check
          inline
          type="radio"
          id={`${idPrefix}-sap-sap`}
          name={`${idPrefix}-sap-classification`}
          label="SAP"
          checked={form.sap_classification === 'sap'}
          onChange={() =>
            onFormChange({ sap_classification: 'sap', sap_has_request: null })
          }
        />
        <Form.Check
          inline
          type="radio"
          id={`${idPrefix}-sap-nao`}
          name={`${idPrefix}-sap-classification`}
          label="Não SAP"
          checked={form.sap_classification === 'nao_sap'}
          onChange={() => onFormChange({ sap_classification: 'nao_sap', sap_has_request: null })}
        />
      </div>
    </Col>
  );
};

export default ChangeSapRequestFields;
